import bridge from '../../../bridge/bridge';
import { Context } from '../../sdk/types';
import {
  InpPerformanceReport,
  InternalLogApi,
  LcpPerformanceReport,
  NetworkPerformanceReport,
  TtfbPerformanceReport,
} from '../types';
import { tryLogAndIgnoreFailure } from '../utils';
import {
  LogContextRequest,
  LogInpPerformanceRequest,
  LogLcpPerformanceRequest,
  LogNetworkPerformanceRequest,
  LogTtfbPerformanceRequest,
  LogUncaughtErrorRequest,
  LogUnhandledRejectionRequest,
} from './actions';

/**
 * Logs uncaught error.
 *
 * @param error Uncaught error to log.
 */
function logUncaughtError(error: string) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogUncaughtErrorRequest(error))
  );
}

/**
 * Logs unhandled rejection.
 *
 * @param error Unhandled rejection to log.
 */
function logUnhandledRejection(rejection: string) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogUnhandledRejectionRequest(rejection))
  );
}

function logLcpPerformance(lcpPerformanceReport: LcpPerformanceReport) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogLcpPerformanceRequest(lcpPerformanceReport))
  );
}

function logTtfbPerformance(ttfbPerformanceReport: TtfbPerformanceReport) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogTtfbPerformanceRequest(ttfbPerformanceReport))
  );
}

function logInpPerformance(inpPerformanceReport: InpPerformanceReport) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogInpPerformanceRequest(inpPerformanceReport))
  );
}

function logNetworkPerformance(
  networkPerformanceReport: NetworkPerformanceReport
) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(
      new LogNetworkPerformanceRequest(networkPerformanceReport)
    )
  );
}

/**
 * Logs context.
 *
 * @param context Context to log.
 */
function logContext(context: Context) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogContextRequest(context))
  );
}

const logUtil: InternalLogApi = {
  logUncaughtError,
  logUnhandledRejection,
  logLcpPerformance,
  logTtfbPerformance,
  logInpPerformance,
  logNetworkPerformance,
  logContext,
};

export { logUtil };
